import { Injectable } from '@angular/core';
import { Response, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
// Este de abajo reemplazarlo por la clase de medical-cases
import { User } from '../../class/user';

@Injectable()
export class MedicalCasesService extends WebService {
    public getMedicalCases(page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined)
            params.append('_page', String(page));
        else
            params.append('_page', '1');

        if (per_page !== null && per_page !== undefined)
            params.append('_limit', String(per_page));
        else
            params.append('_limit', '10');

        if (sort !== null && sort !== undefined)
            params.append('_sort', String(sort));

        if (query !== null && query !== undefined && query !== '')
            params.append('_q', String(query));

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        const options = new RequestOptions({ search: params, headers: this.headers });

        return this.http.get(`${this.apiUrl}/medical-cases-candidates?${params}`, options);
    }

    public infoMedicalCase(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();
        params.append('_with', String('medical_case_events_tracking,medical_case_events_documents,contract,contract.citation'));
        const options = new RequestOptions({ search: params, headers: this.headers });
        return this.http.get(`${this.apiUrl}/medical-cases/${id}?${params}`, { headers: this.headers });
    }

    public newMedicalCase(body: Object): Observable<Response> {
        return this.http.post(`${this.apiUrl}/medical-cases`, JSON.stringify(body), { headers: this.headers });
    }

    public updateMedicalCase(id: number, body: Object): Observable<Response> {
        return this.http.patch(`${this.apiUrl}/medical-cases/${id}`, JSON.stringify(body), { headers: this.headers });
    }

    public deleteMedicalCase(id: number): Observable<Response> {
        return this.http.delete(`${this.apiUrl}/medical-cases/${id}`, { headers: this.headers });
    }

    public downloadPdfReport(caseId: number): Observable<Response> {
        const url = `${this.apiUrl}/medical-cases/${caseId}/download-pdf`;
        const options = new RequestOptions({ 
            headers: this.headers, 
            responseType: ResponseContentType.Blob
        });
        return this.http.get(url, options);
    }


    public getDocumentsMedicalCaseEvent(medical_case_event_id: number) {
        return this.http.get(`${this.apiUrl}/documents-medical-case?medical_case_event_id=${medical_case_event_id}`, { headers: this.headers });
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/medical-cases/medical-cases.service.ts